<template>
  <div class="content container-fluid">
    <!-- Popover for Filter -->
    <popover
      name="popMerchant"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranMerchant"
        :options="colFilter.tran_merchant_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popName"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranName"
        :options="colFilter.tran_name_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popEmail"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranEmail"
        :options="colFilter.tran_email_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popRole"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranRole"
        :options="colFilter.tran_role_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popStatus"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranStatus"
        :options="colFilter.tran_status_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <!-- /Popover for Filter -->

    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Merchant Users</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button class="btn add-btn" @click="add">
            <i class="fa fa-plus"></i>Add User
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Pagination -->
    <div class="row">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="no-col">No</th>
                <th
                  v-if="
                    tokenObj.role == userRoleSuperAdmin ||
                    tokenObj.role == userRoleAdmin
                  "
                >
                  <i
                    class="fa fa-filter"
                    v-popover:popMerchant
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranMerchant.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('merchant')">
                    Merchant
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'merchant'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'merchant_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popName
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranName.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('name')">
                    Name
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'name'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'name_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popEmail
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranEmail.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('email')">
                    Email
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'email'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'email_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popRole
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranRole.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('role')">
                    Role
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'role'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'role_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('createdDate')">
                    Created Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'createdDate'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'createdDate_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('lastLoginDate')">
                    Last Login Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'lastLoginDate'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'lastLoginDate_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="status-col">
                  <i
                    class="fa fa-filter"
                    v-popover:popStatus
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranStatus.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('status')">
                    Status
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'status'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'status_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="action-col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, i) in users" :key="i">
                <td class="no-col">
                  {{
                    paging.CurrentPage * paging.SizePerPage -
                    paging.SizePerPage +
                    i +
                    1
                  }}
                </td>
                <td
                  v-if="
                    tokenObj.role == userRoleSuperAdmin ||
                    tokenObj.role == userRoleAdmin
                  "
                >
                  {{ user.merchant }}
                </td>
                <td>{{ user.name }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.role_display }}</td>
                <td>{{ user.created_date }}</td>
                <td>{{ user.last_login_date }}</td>
                <td>
                  <span
                    class="badge badge-pill"
                    :class="{
                      'badge-success': user.status == statusActive,
                      'badge-danger': user.status == statusInactive,
                    }"
                  >
                    {{ user.status }}
                  </span>
                </td>
                <td class="action-col">
                  <label class="toggler">
                    <input
                      type="checkbox"
                      :checked="user.status == statusActive"
                      @change="toggle(user.id, $event)"
                    />
                    <span class="slider round"></span>
                  </label>
                  <button
                    class="btn btn-sm btn-primary mt-1"
                    @click="edit(user)"
                  >
                    <i class="fa fa-pencil mr-1"></i>Edit
                  </button>
                  <button
                    class="btn btn-sm btn-danger mt-1"
                    @click="remove(user.id)"
                  >
                    <i class="fa fa-trash-o mr-1"></i>Delete
                  </button>
                </td>
              </tr>
              <tr v-if="users && !users.length">
                <td colspan="9" class="text-center">
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="users && users.length">
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          users.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />
          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->

    <!-- Add/Update User Modal -->
    <div class="modal custom-modal fade" id="userModal" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header pt-4">
            <h5 class="modal-title">
              {{ user.id ? "Edit" : "Add" }} Merchant User
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body pt-3">
            <form @submit.prevent="save">
              <div
                class="form-group"
                v-if="
                  tokenObj.role == userRoleSuperAdmin ||
                  tokenObj.role == userRoleAdmin
                "
              >
                <label>Merchant</label>
                <select class="form-control" v-model="user.merchantId" required>
                  <option value>-- Select Merchant --</option>
                  <option
                    v-for="item in merchants"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Name</label>
                <input
                  type="text"
                  v-model="user.name"
                  class="form-control"
                  maxlength="100"
                  required
                />
              </div>
              <div class="form-group">
                <label>Email</label>
                <input
                  type="email"
                  v-model="user.email"
                  class="form-control"
                  maxlength="100"
                  required
                />
              </div>
              <div class="form-group" v-if="!user.id">
                <label>Password</label>
                <input
                  type="password"
                  v-model="user.password"
                  class="form-control"
                  maxlength="50"
                  required
                />
              </div>
              <div class="form-group">
                <label>Role</label>
                <select class="form-control" v-model="user.role" required>
                  <option value>-- Select Role --</option>
                  <option :value="userRoleMerchantAdmin">Merchant Admin</option>
                  <option :value="userRoleMerchantUser">Merchant User</option>
                </select>
              </div>
              <div class="submit-section mt-4">
                <button class="btn btn-primary submit-btn">
                  {{ user.id ? "Update" : "Add" }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- /Add Update User Modal -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import Multiselect from "vue-multiselect";
import $ from "jquery";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      userRoleSuperAdmin: config.USER_ROLE_SUPER_ADMIN,
      userRoleAdmin: config.USER_ROLE_ADMIN,
      userRoleMerchantAdmin: config.USER_ROLE_MERCHANT_ADMIN,
      userRoleMerchantUser: config.USER_ROLE_MERCHANT_USER,
      statusActive: config.STATUS_ACTIVE,
      statusInactive: config.STATUS_INACTIVE,
      users: [],
      //popup
      merchants: [],
      user: {
        id: "",
        merchantId: "",
        name: "",
        email: "",
        password: "",
        role: "",
      },
      //pagination
      searchColFilter: {
        tranMerchant: [],
        tranName: [],
        tranEmail: [],
        tranRole: [],
        tranStatus: [],
      },
      colFilter: {},
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data;
    },
    config() {
      return { headers: { Authorization: `Bearer ${this.tokenObj.token}` } };
    },
    searchFilter() {
      return [
        { name: "tranMerchant", val: this.searchColFilter.tranMerchant },
        { name: "tranName", val: this.searchColFilter.tranName },
        { name: "tranEmail", val: this.searchColFilter.tranEmail },
        { name: "tranRole", val: this.searchColFilter.tranRole },
        { name: "tranStatus", val: this.searchColFilter.tranStatus },
      ];
    },
  },
  watch: {
    "searchColFilter.tranMerchant": function (val, oldVal) {
      this.getUserList();
    },
    "searchColFilter.tranName": function (val, oldVal) {
      this.getUserList();
    },
    "searchColFilter.tranEmail": function (val, oldVal) {
      this.getUserList();
    },
    "searchColFilter.tranRole": function (val, oldVal) {
      this.getUserList();
    },
    "searchColFilter.tranStatus": function (val, oldVal) {
      this.getUserList();
    },
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getUserList();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    getMerchants() {
      API.getAllMerchants({}, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.merchants = response.data.records;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    add() {
      this.user = {
        id: "",
        merchantId: "",
        name: "",
        email: "",
        password: "",
        role: "",
      };
      $("#userModal").modal("show");
    },
    edit(payload) {
      this.user.id = payload.id;
      this.user.merchantId = payload.merchant_id;
      this.user.name = payload.name;
      this.user.email = payload.email;
      this.user.role = payload.role;
      $("#userModal").modal("show");
    },
    getUserList() {
      let param = {
        current_page: this.paging.CurrentPage,
        total_page: this.paging.TotalPage,
        size_per_page: this.paging.SizePerPage,
        sort_by: this.paging.SortBy,
        search_filter: this.searchFilter,
      };
      this.$store.state.isLoading = true;
      API.getMerchantUsers(param, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.users = response.data.records;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.page_count;
            this.colFilter = response.data.col_filter;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    save() {
      let param = {
        id: this.user.id,
        merchant_id:
          this.tokenObj.role == this.userRoleSuperAdmin ||
          this.tokenObj.role == this.userRoleAdmin
            ? this.user.merchantId
            : this.tokenObj.merchant_id,
        name: this.user.name,
        email: this.user.email,
        password: this.user.password,
        role: this.user.role,
      };
      let action = this.user.id ? "update" : "add";
      let text = `Are you sure you want to ${action} the merchant user?`;
      this.$swal({
        title: "Are you sure?",
        text: text,
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveMerchantUser(param, this.config)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.getUserList();
                $("#userModal").modal("hide");
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              console.log(error);
            });
        }
      });
    },
    remove(id) {
      let param = { id: id };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the merchant user?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.isLoading = true;
          API.deleteMerchantUser(param, this.config)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.getUserList();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              console.log(error);
            });
        }
      });
    },
    toggle(id, $event) {
      let isActive = $event.target.checked;
      let param = {
        id: id,
        is_active: isActive,
      };
      this.$store.state.isLoading = true;
      API.toggleMerchantUser(param, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          this.$swal(response.data.message, {
            icon: response.data.success ? "success" : "error",
          });
          if (response.data.success) {
            this.getUserList();
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    //for pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getUserList();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getUserList();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getUserList();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getUserList();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getUserList();
    },
    setSortBy(payload) {
      switch (payload) {
        case "merchant":
          if (this.paging.SortBy === "merchant") {
            this.paging.SortBy = "merchant_desc";
          } else if (this.paging.SortBy === "merchant_desc") {
            this.paging.SortBy = "merchant";
          } else {
            this.paging.SortBy = "merchant";
          }
          break;
        case "name":
          if (this.paging.SortBy === "name") {
            this.paging.SortBy = "name_desc";
          } else if (this.paging.SortBy === "name_desc") {
            this.paging.SortBy = "name";
          } else {
            this.paging.SortBy = "name";
          }
          break;
        case "email":
          if (this.paging.SortBy === "email") {
            this.paging.SortBy = "email_desc";
          } else if (this.paging.SortBy === "email_desc") {
            this.paging.SortBy = "email";
          } else {
            this.paging.SortBy = "email";
          }
          break;
        case "role":
          if (this.paging.SortBy === "role") {
            this.paging.SortBy = "role_desc";
          } else if (this.paging.SortBy === "role_desc") {
            this.paging.SortBy = "role";
          } else {
            this.paging.SortBy = "role";
          }
          break;
        case "createdDate":
          if (this.paging.SortBy === "createdDate") {
            this.paging.SortBy = "createdDate_desc";
          } else if (this.paging.SortBy === "createdDate_desc") {
            this.paging.SortBy = "createdDate";
          } else {
            this.paging.SortBy = "createdDate";
          }
          break;
        case "lastLoginDate":
          if (this.paging.SortBy === "lastLoginDate") {
            this.paging.SortBy = "lastLoginDate_desc";
          } else if (this.paging.SortBy === "lastLoginDate_desc") {
            this.paging.SortBy = "lastLoginDate";
          } else {
            this.paging.SortBy = "lastLoginDate";
          }
          break;
        case "status":
          if (this.paging.SortBy === "status") {
            this.paging.SortBy = "status_desc";
          } else if (this.paging.SortBy === "status_desc") {
            this.paging.SortBy = "status";
          } else {
            this.paging.SortBy = "status";
          }
          break;
      }
      this.getUserList();
    },
  },
  created() {
    this.getUserList();
    this.getMerchants();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Share/MerchantUserList.vue